import type {
  SitemapAggregationsByCategoriesQuery,
  SitemapAggregationsByCategoriesQueryVariables,
} from '@/lib/goliath/goliath.types';

export default async (
  params: SitemapAggregationsByCategoriesQueryVariables,
  progress = true
): Promise<SitemapAggregationsByCategoriesQuery['offers']> =>
  globalThis.$goliathApi<
    SitemapAggregationsByCategoriesQueryVariables,
    SitemapAggregationsByCategoriesQuery,
    'offers'
  >('sitemap-aggregations-by-categories', params, 'offers', progress);
